// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"letter_wrapper__3tX--"};